/**
 * @param  {Object} props
 * @return {Number}
 */
export default function translatePropsIntoHeight(props) {
  switch (props.size) {
    case "large":
      return 48;
    case "small":
    default:
      return 42;
    case "xsmall":
      return 30;
  }
}
